const ALLOWED_HTML_TAGS = [
  'b', 'strong', 'i', 'em', 'u', 's', 'strike',
  'mark', 'sup', 'sub', 'big', 'small',
  'p', 'br',
  'ul', 'ol', 'li',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
]
const ALLOWED_TAGS_REGEX = new RegExp(`^</?(?:${ALLOWED_HTML_TAGS.join('|')})>$`, 'i')
const ALL_TAGS_REGEX = /<\/?[^>]+>/g

function parseHtml(text) {
  if (typeof text !== 'string') return text
  text = text.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
  return text.replace(ALL_TAGS_REGEX, (match) => {
    if (ALLOWED_TAGS_REGEX.test(match)) {
      return match
    } else {
      return match.replace(/</g, '&lt;').replace(/>/g, '&gt;')
    }
  })
}